module.exports = __webpack_public_path__ + "static/media/nop-logo.a92c1840.png";